module.exports = __webpack_public_path__ + "e7e98b69acd9ac2c84becd2ac5965771.svg";